export const ELEMENT_DEFAULT = "p";
